import _asyncToGenerator from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
import axios from '@vtblife/axios';
import { cachedRequest, cmsDataUrlByEnvironmentMap } from '@vtblife/block-kit-utils';
export function fetchQuizIndexData(_x) {
  return _fetchQuizIndexData.apply(this, arguments);
}
function _fetchQuizIndexData() {
  _fetchQuizIndexData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var key, environment, _yield$cachedRequest, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          key = _ref.key, environment = _ref.environment;
          _context2.next = 3;
          return cachedRequest(key, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", axios.get("".concat(cmsDataUrlByEnvironmentMap[environment], "/json/quiz-index.json")));
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          })));
        case 3:
          _yield$cachedRequest = _context2.sent;
          data = _yield$cachedRequest.data;
          return _context2.abrupt("return", data);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchQuizIndexData.apply(this, arguments);
}